import React, { useEffect, useState } from "react";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import { Form } from "react-bootstrap";
import "./Create_Account_Step5.css";
import { getGoals } from "../../../../utils/gymOwnerApi";

const Create_Account_Step5 = ({ setStep, formData, setFormData }) => {
  const [selected, setSelected] = useState(
    formData?.goal ? { id: formData.goal, name: formData.goal_name } : null
  ); const [goalOptions, setGoalOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const apiGoals = async () => {
    const response = await getGoals();
    if (response.success && response.data) {
      setGoalOptions(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    apiGoals();
  }, []);

  const handleNext = () => {
    if (!selected) {
      setError("Please select a goal to continue");
      return;
    }
    setFormData((prev) => ({
      ...prev,
      goal: selected.id,
    }));
    setStep(6);
  };

  return (
    <section className="step1_wrapper step3_wrapper step5_wrapper">
      <Form_Header step={5} totalSteps={6} />
      <div className="weight_selection_div business_constitution_div">
        <h2 className="select_title">Select Your Goal</h2>

        <div className="goal_wrapper">
          {loading ? (
            <p className="text-center">Loading goals...</p>
          ) : (
            <Form>
              {goalOptions.map((goal) => (
                <div
                  key={goal.id}
                  className={`goal_item ${selected?.id === goal.id ? "active" : ""}`}
                  onClick={() => {
                    setSelected({ id: goal.id, name: goal.name });
                    setError("");
                  }}
                >
                  <span className="goal_text">{goal.name}</span>
                  <Form.Check
                    type="radio"
                    name="goal"
                    checked={selected?.id === goal.id}
                    readOnly
                  />
                </div>
              ))}
            </Form>
          )}

          {/* Validation Error */}
          {error && <p className="text-danger text-center mt-2">{error}</p>}
        </div>

        <div className="form_btn_holder">
          {
            !loading && <>
              <White_Btn btnText="Back" onClick={() => setStep(4)} />
              <Common_Btn btnText="Next" onClick={handleNext} />
            </>
          }
        </div>
      </div>
    </section>
  );
};

export default Create_Account_Step5;